export const LIMITS = {
	maxCreatedCareReceiverAccounts: {
		freemium: 1,
		premium: 3,
		business: Infinity,
	},
	maxConnectionsPerCareReceiver: {
		freemium: 3,
		premium: Infinity,
		business: Infinity,
	},
} as const;
